const {
  fetchPaymentSystems,
  fetchSkrillPaymentMethods,
} = require('./api/purchases');

const EURO_CURRENCY_RATES = {
  USD: 1.06,
};

const EUR_COUNTRIES = [
  'AT',
  'BE',
  'CY',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PT',
  'SK',
  'SI',
  'ES',
];

const PAYMENTWALL_CREDITCARD_METHOD_CODES = [
  'gateway',
  'cc',
  'ccbrazil',
  'allthegate',
  'unionpay',
  'ccbrazilhipercard',
  'bancontact',
];

const BASE_COUNTRIES = ['DE', 'AT'];

const PAYONE_COUNTRIES = [
  'AT',
  'BE',
  'CY',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PT',
  'SK',
  'SI',
  'ES',
  'CH',
  'US',
  'CA',
  'AU',
];

const SKRILL_COUNTRIES = [
  'AT',
  'BE',
  'CY',
  'EE',
  'FI',
  'DE',
  'GR',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PT',
  'SK',
  'SI',
  'FR',
  'ES',
  'US',
  'CA',
  'CH',
  'AU',
  'CO',
  'AR',
  'CL',
  'MX',
  'GB',
  'BR',
  'CZ',
  'PL',
  'DK',
  'NO',
];

const PAYSAFECARD_CURRENCIES_COUNTRIES = {
  EUR: [
    'AT',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DK',
    'FI',
    'GE',
    'GI',
    'HR',
    'HU',
    'IE',
    'IS',
    'IT',
    'LU',
    'LV',
    'MT',
    'NL',
    'NO',
    'PT',
    'RO',
    'SI',
    'SK',
    'CA',
    'MX',
    'PE',
    'PY',
    'UY',
    'AE',
    'KW',
    'SA',
    'AU',
    'BE',
    'DE',
    'ES',
    'FR',
    'GR',
    'LT',
    'ME',
    'NZ',
    'PL',
    'SE',
    'GB',
  ],
  CHF: [
    'AT',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DK',
    'FI',
    'GE',
    'GI',
    'HR',
    'HU',
    'IE',
    'IT',
    'LU',
    'LV',
    'MT',
    'NL',
    'NO',
    'PT',
    'RO',
    'SI',
    'SK',
    'CA',
    'MX',
    'PE',
    'UY',
    'AE',
    'KW',
    'SA',
    'BE',
    'DE',
    'ES',
    'FR',
    'LT',
    'NZ',
    'PL',
    'SE',
    'GB',
  ],
  PLN: [
    'AT',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DK',
    'FI',
    'GE',
    'GI',
    'HR',
    'HU',
    'IE',
    'IT',
    'LU',
    'LV',
    'MT',
    'NL',
    'NO',
    'PT',
    'RO',
    'SI',
    'SK',
    'BE',
    'DE',
    'ES',
    'FR',
    'LT',
    'PL',
    'SE',
    'GB',
  ],
  CAD: ['CA'],
  USD: [
    'AT',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DK',
    'FI',
    'GE',
    'GI',
    'HR',
    'HU',
    'IE',
    'IS',
    'IT',
    'LU',
    'LV',
    'MT',
    'NL',
    'NO',
    'PT',
    'RO',
    'SI',
    'SK',
    'CA',
    'MX',
    'PE',
    'PY',
    'UY',
    'AE',
    'KW',
    'SA',
    'BE',
    'DE',
    'ES',
    'FR',
    'LT',
    'NZ',
    'PL',
    'SE',
    'GB',
    'US',
  ],
};

PAYSAFECARD_CURRENCIES_COUNTRIES.GBP = PAYSAFECARD_CURRENCIES_COUNTRIES.CHF;
PAYSAFECARD_CURRENCIES_COUNTRIES.CZK = PAYSAFECARD_CURRENCIES_COUNTRIES.PLN;
PAYSAFECARD_CURRENCIES_COUNTRIES.HUF = PAYSAFECARD_CURRENCIES_COUNTRIES.PLN;
PAYSAFECARD_CURRENCIES_COUNTRIES.DKK = PAYSAFECARD_CURRENCIES_COUNTRIES.PLN;
PAYSAFECARD_CURRENCIES_COUNTRIES.SEK = PAYSAFECARD_CURRENCIES_COUNTRIES.PLN;

const VISA_MASTERCARD_AMEX = 'vimaam';
const VISA_MASTERCARD = 'vima';
const VISA = 'vi';
const MASTERCARD = 'ma';
const FALLBACK_STRIPE_IMAGE_ID = VISA_MASTERCARD_AMEX;

const fetchPaymentwallMethods = async (
  apiUrl,
  country,
  isStripeMethodEnabled,
) => {
  if (BASE_COUNTRIES.includes(country)) {
    return [];
  }
  return fetchPaymentSystems(apiUrl, country)
    .then(
      (methods) => {
        if (!Array.isArray(methods)) {
          return [];
        }
        if (!isStripeMethodEnabled && !PAYONE_COUNTRIES.includes(country)) {
          return methods;
        }
        return methods.filter(
          (method) => !PAYMENTWALL_CREDITCARD_METHOD_CODES.includes(method.id),
        );
      },
      () => [],
      // eslint-disable-next-line camelcase
    )
    .then((result) =>
      result.map(({ img_url, id, ...paymentSystem }) => ({
        ...paymentSystem,
        type: 'paymentwall',
        img: img_url,
        ps: id,
        img_url,
        id,
      })),
    );
};

const fetchSkrillMethods = async (apiUrl, ipCountry) => {
  const methods = await fetchSkrillPaymentMethods(apiUrl, ipCountry);
  return methods.map(
    ({ image, methodSymbol, methodName, minimumQuantity }) => ({
      type: 'skrill',
      paymentMethod: methodSymbol,
      name: methodName,
      img: image,
      minimumQuantity,
    }),
  );
};

const getPaysafecardMethod = (country) => ({
  paysafecard: {
    type: 'paysafecard',
    icon: country === 'US' ? 'paysafecard_us' : 'paysafecard',
    name: 'paysafecard',
  },
});

const HUAWEIIAP = { huaweiiap: { type: 'huaweiiap', icon: 'huaweiiap' } };
const GOOGLEIAP = { googleplay: { type: 'googleplay', icon: 'googleplay' } };
const AMAZONIAP = { amazoniap: { type: 'amazoniap', icon: 'amazoniap' } };
const STRIPECC = { stripecc: { type: 'stripecc', icon: 'stripecc' } };
const VISACC = { visa: { type: 'creditcard', icon: 'visa' } };
const MASTERCARDCC = { mastercard: { type: 'creditcard', icon: 'mastercard' } };
const LOOTTICKET = { lootTicket: { type: 'lootTicket', icon: 'lootTicket' } };
const SOFORT = {
  sofort: { type: 'sofortueberweisung', icon: 'sofortueberweisung' },
};

const getInitialPurchaseTypes = ({
  platform,
  isStripeMethodEnabled,
  currency,
  ipCountry,
  country,
  acceptTicket,
  productDataFetched,
}) => {
  const availablePurchaseTypes = {};

  if (platform === 'huawei' && productDataFetched) {
    Object.assign(availablePurchaseTypes, HUAWEIIAP);
  }

  if (platform === 'amazon' && productDataFetched) {
    Object.assign(availablePurchaseTypes, AMAZONIAP);
  }

  if (platform === 'google' && productDataFetched) {
    Object.assign(availablePurchaseTypes, GOOGLEIAP);
  }

  if (platform === 'web') {
    if (isStripeMethodEnabled) {
      Object.assign(availablePurchaseTypes, STRIPECC);
    } else if (PAYONE_COUNTRIES.includes(country)) {
      Object.assign(availablePurchaseTypes, VISACC);
      Object.assign(availablePurchaseTypes, MASTERCARDCC);
    }
    if (PAYSAFECARD_CURRENCIES_COUNTRIES[currency]?.includes(ipCountry)) {
      Object.assign(availablePurchaseTypes, getPaysafecardMethod(ipCountry));
    }
    if (BASE_COUNTRIES.includes(country)) {
      Object.assign(availablePurchaseTypes, SOFORT);
    }
  }

  if (acceptTicket) {
    Object.assign(availablePurchaseTypes, LOOTTICKET);
  }

  return availablePurchaseTypes;
};

module.exports = {
  fetchPaymentwallMethods,
  fetchSkrillMethods,
  getInitialPurchaseTypes,
  LOOTTICKET,
  PAYSAFECARD_CURRENCIES_COUNTRIES,
  BASE_COUNTRIES,
  SKRILL_COUNTRIES,
  VISA,
  VISA_MASTERCARD,
  VISA_MASTERCARD_AMEX,
  MASTERCARD,
  FALLBACK_STRIPE_IMAGE_ID,
  EURO_CURRENCY_RATES,
  EUR_COUNTRIES,
};
